import { Instance } from '@const/consts'

const domain = 'https://greendocs.infologistics.'
const domainBR = 'https://greendocs.ilsbrasil.'
const domainVN = 'https://greendocs.ilsglobal.'

export const dropdownItems = [
  {
    name: Instance.GLOBAL,
    translation: domain + Instance.GLOBAL
  },
  {
    name: Instance.BR,
    translation: domainBR + Instance.BR
  },
  {
    name: Instance.VN,
    translation: domainVN + Instance.VN
  },
  {
    name: Instance.RU,
    translation: domain + Instance.RU
  },
  {
    name: Instance.ZA,
    translation: domain + Instance.ZA
  }
]
